import React, { useState, useEffect } from "react";
import { components } from "react-select";
import * as R from "ramda";
import { noop } from "utils/General";

import { FIELD_IDS } from "EventLight/Sessions/AddSessionModal/constants";

const MultiValueLabel = props => {
  const {
    children = "",
    data = {},
    setSpeakerIsPublicInStore = noop,
    setHasChanges = noop
  } = props;

  if (!children) {
    return null;
  }

  const childrenArray = children.split(" ");

  const id =
    childrenArray.length > 2 ? childrenArray[childrenArray.length - 1] : "";

  const speakers = R.propOr([], FIELD_IDS.SPEAKERS)(data);

  const isPublic = R.propOr(
    true,
    "isSpeakerPublic",
    R.find(x => x.id === id)(speakers || [])
  );

  const newLabel = R.propOr(
    "",
    "name",
    R.find(x => x.id === id)(speakers || [])
  );

  const [isSpeakerPublic, setIsSpeakerPublic] = useState(isPublic);

  useEffect(() => {
    setIsSpeakerPublic(isPublic);
  }, [isPublic]);

  const toggleSpeakerPublic = id => {
    setIsSpeakerPublic(!isSpeakerPublic);
    setSpeakerIsPublicInStore({
      isSpeakerPublic: !isSpeakerPublic,
      id: id
    });
    setHasChanges(true);
  };

  return (
    <components.MultiValueLabel {...props}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          padding: "4px 8px",
          cursor: "pointer",
          fontSize: "14px"
        }}
        onClick={() => toggleSpeakerPublic(id)}
        onTouchEnd={() => toggleSpeakerPublic(id)}
        onMouseDown={e => {
          e.stopPropagation();
        }}
      >
        {!isSpeakerPublic && (
          <span
            className="material-icons-outlined"
            style={{ marginRight: 4, fontSize: 14 }}
          >
            visibility_off
          </span>
        )}
        {newLabel}
      </div>
    </components.MultiValueLabel>
  );
};

export default MultiValueLabel;
